import React from 'react';
import { Link } from 'react-router-dom';
import { FiLock, FiUnlock, FiUsers } from 'react-icons/fi';
import { fullUrl } from '../../api';
import { useLanguage } from '../../i18n';
import { BLUE, BLUE_GRADIENT, compactNumber } from './brand';

/**
 * One group row/card: group **logo**, nickname, public/private chip, my role,
 * the member count, the last message and — for public groups — a join button.
 */
export default function GroupCard({ group, onJoin }) {
  const { t } = useLanguage();
  const url = `/groups/${group.id}`;
  const role = group.role || '';
  const roleLabel = role === 'owner' ? t('groupRoleOwner')
    : role === 'admin' ? t('groupRoleAdmin') : t('groupRoleMember');
  const last = group.last_message;

  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 overflow-hidden anim-fade-up">
      {/* the group cover (រូបភាពគម្របក្រុម) */}
      <Link to={url} className="block">
        <span
          className="block h-14"
          style={{ background: group.cover ? `url(${fullUrl(group.cover)}) center/cover` : BLUE_GRADIENT }}
        />
      </Link>
      <div className="p-3">
        <div className="flex items-center gap-3 -mt-7">
          <Link to={url} className="shrink-0">
            {group.avatar ? (
              <img
                src={fullUrl(group.avatar)}
                alt={group.name}
                className="w-12 h-12 rounded-xl object-cover ring-2 ring-white dark:ring-gray-900"
              />
            ) : (
              <span
                className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-extrabold ring-2 ring-white dark:ring-gray-900"
                style={{ background: BLUE }}
              >
                {(group.name || 'G').slice(0, 1).toUpperCase()}
              </span>
            )}
          </Link>
          <div className="min-w-0 flex-1 pt-6">
          <div className="flex items-center gap-1.5">
            <Link to={url} className="font-extrabold text-sm truncate hover:underline">{group.name}</Link>
            {group.is_public
              ? <FiUnlock className="w-3 h-3 text-emerald-600 shrink-0" title={t('groupPublic')} />
              : <FiLock className="w-3 h-3 text-gray-400 shrink-0" title={t('groupPrivate')} />}
            {group.unread > 0 && (
              <span className="ml-1 min-w-[18px] h-[18px] px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center" style={{ background: '#ef4444' }}>
                {group.unread > 99 ? '99+' : group.unread}
              </span>
            )}
          </div>
          <p className="text-[11px] text-gray-500 truncate">
            <FiUsers className="w-3 h-3 inline" /> {compactNumber(group.member_count)} {t('groupMembers')}
            {group.is_member && <> · <span className="font-bold">{roleLabel}</span></>}
          </p>
          {last && (
            <p className="text-[11px] text-gray-400 truncate">
              {last.sender_name ? `${last.sender_name}: ` : ''}{last.text || (last.audio ? '🎤' : '🖼️')}
            </p>
          )}
        </div>
        {group.is_member ? (
          <Link
            to={url}
            className="shrink-0 px-3 py-1.5 rounded-full text-xs font-bold text-white"
            style={{ background: BLUE }}
          >
            {t('groupChat')}
          </Link>
        ) : group.is_public ? (
          <button
            type="button"
            onClick={() => onJoin && onJoin(group)}
            className="shrink-0 px-3 py-1.5 rounded-full text-xs font-bold text-white"
            style={{ background: BLUE }}
          >
            {t('groupJoinOpen')}
          </button>
        ) : (
          <span className="shrink-0 text-[10px] font-bold px-2 py-1 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500">
            {t('groupJoinByLink')}
          </span>
        )}
        </div>
      </div>
    </div>
  );
}